import { http } from '@/http'

// CDEF014: bandeja del firmante de la empresa y expediente de cada firma. Quién firma sale del token, no de la petición.
export default {
  inbox()                           { return http.get('/signatures/inbox') },
  requestBatch(signerId, items)     { return http.post('/signatures/batch/request', { signerId, items }) },
  confirmBatch(signerId, items, code) { return http.post('/signatures/batch/confirm', { signerId, items, code }) },
  batches(signerId)                 { return http.get('/signatures/batches', { params: { signerId } }) },
  retryBatch(authorizationId, signerId) { return http.post(`/signatures/batches/${authorizationId}/retry`, null, { params: { signerId } }) },
  requestContact(signerId, value)   { return http.post('/signatures/contact/request', { signerId, value }) },
  confirmContact(signerId, code)    { return http.post('/signatures/contact/confirm', { signerId, code }) },
  uploadImage(signerId, file) {
    const data = new FormData()
    data.append('file', file)
    return http.post(`/signatures/signers/${signerId}/signature-image`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
  },
  documentSignatures(documentId)    { return http.get(`/signatures/documents/${documentId}`) },
  evidence(signatureId)             { return http.get(`/signatures/${signatureId}/evidence`, { responseType: 'blob' }) },
}
